export const categories = [
  {
    id: "celebrity-scandal",
    name: "明星黑料",
    slug: "celebrity-scandal",
    description: "最新明星八卦、娱乐圈内幕、艺人翻车事件全记录",
    icon: "ri-star-line",
    articleCount: 128,
    featured: true,
  },
  {
    id: "influencer-flop",
    name: "网红翻车",
    slug: "influencer-flop",
    description: "网红主播翻车现场、直播事故、人设崩塌合集",
    icon: "ri-live-line",
    articleCount: 96,
    featured: true,
  },
  {
    id: "social-hot",
    name: "社会热点",
    slug: "social-hot",
    description: "社会热点事件深度爆料、真实内幕独家披露",
    icon: "ri-fire-line",
    articleCount: 87,
    featured: true,
  },
  {
    id: "exclusive-expose",
    name: "独家曝光",
    slug: "exclusive-expose",
    description: "911吃瓜网独家调查报道、一手猛料抢先看",
    icon: "ri-spy-line",
    articleCount: 54,
    featured: false,
  },
  {
    id: "daily-gossip",
    name: "每日吃瓜",
    slug: "daily-gossip",
    description: "每日最新最热的吃瓜合集，一网打尽全天猛料",
    icon: "ri-newspaper-line",
    articleCount: 203,
    featured: false,
  },
  {
    id: "deep-dive",
    name: "深度扒皮",
    slug: "deep-dive",
    description: "深度挖掘事件真相，全方位还原吃瓜现场",
    icon: "ri-search-eye-line",
    articleCount: 41,
    featured: false,
  },
];

export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  categoryName: string;
  image: string;
  date: string;
  views: number;
  comments: number;
  tags: string[];
  featured: boolean;
  content: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子 酒店共度8小时实锤曝光",
    slug: "top-star-secret-date-exposed",
    excerpt: "据知情人士爆料，该男星与一名圈外女性在某五星级酒店共处长达8小时，期间多次被拍到亲密互动。该男星此前一直以单身人设示人，此次实锤照片流出引发粉丝集体破防。",
    category: "celebrity-scandal",
    categoryName: "明星黑料",
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20hotel%20entrance%20at%20night%20with%20paparazzi%20camera%20flash%20effect%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20low%20key%20lighting%2C%20warm%20dark%20tones&width=800&height=500&seq=article-01-full&orientation=landscape",
    date: "2026-07-06",
    views: 285000,
    comments: 3421,
    tags: ["顶流", "恋情曝光", "实锤"],
    featured: true,
    content: '<p>7月6日凌晨，有网友在某社交平台发布了一组照片，照片中清晰可见某当红顶流男星与一名年轻女子先后进入北京某五星级酒店，直到次日早晨8点才分别离开。照片拍摄角度专业，疑似为蹲守已久的狗仔团队所为。</p><p>据爆料人称，该男星当晚10点左右抵达酒店地下车库，由一名助理陪同下进入电梯。约20分钟后，一名身穿黑色连衣裙、头戴棒球帽的女子独自进入同一酒店，同样选择了地下车库通道。两人在酒店内共处长达8小时。</p><h3>实锤照片逐一曝光</h3><p>本次曝光的照片共有五张：第一张为该男星进入酒店的画面，第二张为神秘女子随后进入的画面，第三张为两人在酒店大堂咖啡厅短暂交谈的远景照，第四张为清晨女子离开时略显匆忙的背影，第五张为男星在助理陪同下离开酒店的画面。</p><p>尤其值得注意的是第三张照片中，虽然拍摄距离较远，但可以辨认出两人交谈时距离极近，男星甚至伸手为女子整理头发，动作亲密程度远超普通朋友关系。</p><h3>单身人设崩塌 粉丝集体破防</h3><p>该男星自出道以来一直以专注事业、至今单身的形象示人，曾在多次采访中表示没有时间谈恋爱。此番照片曝光后，其粉丝群体出现严重分裂：一部分粉丝坚持认为照片是伪造的，要求工作室出面辟谣；另一部分粉丝则表达了失望之情，认为受到了欺骗。</p><p>截至目前，该男星的工作室尚未就此事发表任何声明。有媒体试图联系其经纪人，但电话始终无人接听。而据与该男星有合作关系的品牌方透露，已有两个品牌表示将重新评估代言合作关系。</p><h3>神秘女子身份成谜</h3><p>关于照片中女子的身份，网络上出现了多个版本的猜测。有网友通过对比发现，该女子疑似为某影视公司的新人演员，两个月前曾与该男星在同一剧组有过短暂合作。也有说法称其是一名圈外人士，从事金融行业。</p><p>本网将持续关注事件进展，为您带来最新报道。</p>',
  },
  {
    id: 2,
    title: "带货一姐直播间翻车现场 假货当场被品牌方打脸",
    slug: "live-stream-sale-fake-exposed",
    excerpt: "知名带货主播在直播间售卖某国际大牌护肤品时，被品牌官方微博当场辟谣称从未与该主播合作。直播间弹幕瞬间爆炸，该主播仓皇下播，至今未回应。",
    category: "influencer-flop",
    categoryName: "网红翻车",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20bright%20ring%20light%20and%20product%20display%2C%20chaotic%20atmosphere%2C%20warm%20interior%20lighting%2C%20modern%20streaming%20setup%2C%20editorial%20photography&width=800&height=500&seq=article-02-full&orientation=landscape",
    date: "2026-07-06",
    views: 432000,
    comments: 5621,
    tags: ["直播翻车", "假货", "带货"],
    featured: true,
    content: '<p>7月6日晚间，拥有3000万粉丝的知名带货主播XX姐在直播中遭遇了职业生涯最严重的一次翻车。当她正在热情洋溢地介绍一款自称品牌官方合作的国际大牌护肤品时，该品牌的官方微博突然发文辟谣，场面一度极为尴尬。</p><h3>直播间里的一幕</h3><p>当晚8点，XX姐如往常一样开启直播。在介绍到第三款产品时，她拿出一套标价899元的某国际大牌精华套装，声称这是品牌方特别给到直播间的福利价，专柜卖1280元，今天直播间只要899，还送三件小样。</p><p>就在直播间下单人数突破2000单的时候，弹幕中突然有人刷屏：品牌方发微博了，说是假的！起初XX姐并未在意，继续催促大家下单，但弹幕中质疑的声音越来越多。她不得不停下来查看手机，随后脸色骤变。</p><h3>品牌的官方打脸</h3><p>原来，该品牌官方微博在5分钟前发布了一条声明：近日收到多位消费者咨询，关于我司产品在某直播间销售一事。我司郑重声明：我司从未授权任何直播渠道销售本公司产品，所有声称品牌官方合作的直播销售均为虚假宣传。请消费者通过官方旗舰店及专柜购买正品。</p><p>这条微博虽然没有直接点名，但发布时间恰好与直播重合，被网友视为精准打脸。该微博在15分钟内转发量突破5万，评论区更是一片哗然。</p><h3>仓皇下播 至今未回应</h3><p>意识到事态严重后，XX姐以身体不适为由匆匆下播，整个直播仅持续了不到40分钟。事后，大量已下单的消费者涌入其客服系统要求退款。据知情人士透露，当晚的销售额至少有200万元面临退款。</p><p>目前，XX姐的全部社交账号评论区已被攻陷。她的团队至今未就此事发表任何正式回应，多个合作品牌已悄悄下架了与其相关的内容。市场监管部门也表示已关注到此事，将依法调查。</p>',
  },
  {
    id: 3,
    title: "某知名企业高管聊天记录泄露 涉及巨额利益输送",
    slug: "corporate-executive-chat-leak",
    excerpt: "一份长达200页的聊天记录在社交平台疯传，内容涉及某上市公司高管与供应商之间的利益输送细节。涉事企业股价次日暴跌12%，监管部门已介入调查。",
    category: "social-hot",
    categoryName: "社会热点",
    image: "https://readdy.ai/api/search-image?query=Serious%20corporate%20office%20environment%20with%20documents%20scattered%20on%20desk%2C%20dramatic%20overhead%20lighting%2C%20tense%20atmosphere%2C%20dark%20warm%20tones%2C%20business%20setting%2C%20cinematic%20photography&width=800&height=500&seq=article-03-full&orientation=landscape",
    date: "2026-07-05",
    views: 567000,
    comments: 8932,
    tags: ["聊天记录", "利益输送", "企业"],
    featured: true,
    content: '<p>7月5日，一份据称来自某知名上市公司高管的聊天记录在多个社交平台疯传。这份长达200页的记录详细披露了该公司高管与多家供应商之间疑似利益输送的内幕，引发了资本市场和监管层的高度关注。</p><h3>聊天记录曝光始末</h3><p>据了解，这份聊天记录最早出现在一个匿名论坛上，发帖者自称是该公司的一名前员工，因看不惯公司的腐败行为决定将其公之于众。记录内容涵盖了2024年至2026年期间，涉事高管与至少五家供应商之间的微信聊天详情。</p><p>在这些聊天记录中，高管多次向供应商暗示合作需要诚意，并直接提出了回扣比例。其中一段对话显示，该高管明确表示：这批设备采购，正常报价基础上加15%，多出来的部分按老规矩处理。供应商则回复：明白，已经安排。</p><h3>股价暴跌 监管介入</h3><p>消息传出后，涉事公司股价在次日开盘后迅速下跌，盘中一度跌幅达到15%，最终以12%的跌幅收盘，市值蒸发超过80亿元。多家券商紧急下调了该公司的评级。</p><p>与此同时，证监会和当地公安经侦部门均已表态，称已关注到相关情况，将依法开展调查。该公司在收盘后发布了一份简短的公告，称公司将积极配合相关部门的调查，但未对聊天记录的真实性做出直接回应。</p><h3>行业震动</h3><p>此事件在行业内引发强烈震动。多家与该涉事公司有业务往来的企业纷纷自查内部流程。业内人士表示，此次曝光的利益输送模式在行业内并非个例，可能会引发更大范围的监管审查。</p><p>本网将持续关注此事的调查进展。</p>',
  },
  {
    id: 4,
    title: "95后小花疑似整容失败 最新生图与精修差距大到离谱",
    slug: "actress-plastic-surgery-rumor",
    excerpt: "某95后当红小花最新机场生图流出，面部浮肿明显，与工作室发布的精修图判若两人。整容医生分析称疑似面部填充过度，恢复期尚未结束就急着复工。",
    category: "celebrity-scandal",
    categoryName: "明星黑料",
    image: "https://readdy.ai/api/search-image?query=Airport%20terminal%20scene%20with%20fashionable%20woman%20wearing%20sunglasses%20and%20mask%20walking%20quickly%2C%20paparazzi%20style%20photography%2C%20bright%20natural%20lighting%2C%20clean%20modern%20airport%20architecture&width=800&height=500&seq=article-04-full&orientation=landscape",
    date: "2026-07-05",
    views: 198000,
    comments: 2845,
    tags: ["整容", "生图", "95后"],
    featured: false,
    content: '<p>7月5日，一组某95后当红小花的机场最新生图在网络上疯传。照片中的她面部浮肿明显，与工作室前一天发布的精修图判若两人，引发了网友对她是否整容失败的激烈讨论。</p><h3>生图与精修的惊人差距</h3><p>有网友将工作室发布的宣传照与此次机场生图进行了同角度对比：精修图中的她五官精致、下颌线清晰、面部轮廓流畅自然；而生图中的她面部明显浮肿，苹果肌位置异常饱满，下颌线几乎消失。两张照片放在一起，除了服装相同外，几乎认不出是同一个人。</p><h3>整容医生专业分析</h3><p>多位不愿透露姓名的医美从业者在看到对比图后表示，从生图判断，该女星可能进行了面部脂肪填充或玻尿酸注射，且剂量可能偏大。一位资深整容医生分析称：她的面部肿胀程度说明填充手术距离现在不会超过两周，还处于恢复期。这个阶段应该尽量避免公开露面，但她选择冒着风险复工，可能是合约压力太大。</p><h3>工作室沉默 粉丝互撕</h3><p>截至发稿时，该女星的工作室未对生图争议做出任何回应。而其粉丝群体已分裂成两派：一派坚持认为生图是恶意P图，誓死捍卫偶像；另一派则失望地表示：要的是真实的她，不是活在滤镜里的人。更有化妆师出身的网友逐帧分析了她的妆容技巧，发现其日常妆容本身就具有极强的修饰效果。</p>',
  },
  {
    id: 5,
    title: "知名吃播博主被曝假吃 镜头外全吐了后期剪辑穿帮",
    slug: "mukbang-fake-eating-exposed",
    excerpt: "有细心网友逐帧分析某千万粉丝吃播博主的最新视频，发现多处剪辑痕迹，且桌面反光中清晰可见垃圾桶。该博主此前以大胃王人设走红，如今翻车引发全网嘲讽。",
    category: "influencer-flop",
    categoryName: "网红翻车",
    image: "https://readdy.ai/api/search-image?query=Food%20mukbang%20table%20filled%20with%20colorful%20dishes%20and%20camera%20equipment%2C%20warm%20cozy%20interior%20lighting%2C%20modern%20dining%20setup%2C%20editorial%20food%20photography&width=800&height=500&seq=article-05-full&orientation=landscape",
    date: "2026-07-04",
    views: 321000,
    comments: 4521,
    tags: ["吃播", "假吃", "剪辑"],
    featured: false,
    content: '<p>近日，一位拥有千万粉丝的知名吃播博主被网友扒出假吃实锤。有细心网友逐帧分析了该博主发布的最新一期视频，发现了多处剪辑痕迹，最致命的是桌面反光中清晰可见一个垃圾桶——这意味着她一面在镜头前大快朵颐，一面在镜头外将食物吐掉。</p><h3>逐帧分析揭露真相</h3><p>在热心网友发布的解析视频中，可以看到多个关键破绽：视频中博主的筷子夹起食物后，画面出现了不自然的跳帧；每一口咀嚼后，剪辑点恰好都落在了吞咽动作之前；而最直接的证据是，博主面前的光滑桌面上反射出了一个形似垃圾桶的物体轮廓。按照视频中的进食量计算，没有人能在吃完十几碗面后不出现明显的腹部变化，而她的身材全程保持纤细。</p><h3>日入百万的大胃王人设崩塌</h3><p>该博主自三年前开始做吃播内容，凭借娇小身材却能吃下惊人食量的反差感迅速走红，全网粉丝累计超过1500万。据业内人士估算，其月收入在百万元以上，主要来源于平台分成和食品品牌广告。如今假吃实锤曝光后，已有多家合作品牌宣布暂停与其的商业合作。</p><h3>网友评论炸锅</h3><p>事件发酵后，相关话题迅速登上多个平台热搜。有网友调侃：原来大胃王的胃是垃圾桶做的。更多人则表达了愤怒：欺骗粉丝感情，浪费食物，这种人就应该被全网封杀。目前该博主已将所有社交账号设为私密状态，未做任何公开回应。</p>',
  },
  {
    id: 6,
    title: "某城市地铁冲突事件完整视频曝光 官方通报与事实严重不符",
    slug: "subway-conflict-full-video",
    excerpt: "此前引发热议的某市地铁冲突事件，官方通报称双方已和解。然而最新流出的完整监控视频显示，事件真相与官方说法存在重大出入。当事人已委托律师准备起诉。",
    category: "social-hot",
    categoryName: "社会热点",
    image: "https://readdy.ai/api/search-image?query=Subway%20station%20platform%20scene%20with%20crowded%20commuters%2C%20security%20camera%20style%20perspective%2C%20dramatic%20overhead%20fluorescent%20lighting%2C%20urban%20underground%20setting&width=800&height=500&seq=article-06-full&orientation=landscape",
    date: "2026-07-04",
    views: 689000,
    comments: 12340,
    tags: ["地铁", "监控视频", "真相"],
    featured: true,
    content: '<p>此前引发全网热议的某市地铁冲突事件有了重大反转。官方此前通报称当事双方已达成和解，但7月4日流出的完整监控视频显示，事件真相与官方通报存在重大出入。</p><h3>官方通报与视频的三大矛盾</h3><p>第一，官方通报称双方因口角发生推搡，各有过错。但视频显示，是一方主动上前推搡另一方，后者全程基本处于被动防御状态。第二，官方称保安人员及时制止了冲突，但视频显示保安在事发后约3分钟才到达现场。第三，官方称双方经调解后自愿达成和解，但视频中明显可见被推搡一方是被工作人员劝说了近40分钟才勉强在协议上签字。</p><h3>当事人委托律师 准备起诉</h3><p>据了解，被推搡一方的当事人已在7月4日下午正式委托律师事务所代理此案。代理律师在接受采访时表示：我的当事人当时是在极度疲劳和精神压力下被迫签字，这份和解协议的有效性存在严重问题。我们将就地铁运营方在事件处理中的程序违法和通报不实行为提起诉讼。</p><h3>官方紧急回应</h3><p>在完整视频曝光后，该市地铁运营公司在当天晚间发布了第二份声明：关于今日网络上流传的所谓完整视频，我司正在进行内部核查。如发现此前通报存在不实之处，将严肃追究相关人员责任，并向当事人郑重道歉。</p>',
  },
  {
    id: 7,
    title: "某综艺节目后台撕逼录音流出 两位导师彻底闹翻",
    slug: "variety-show-backstage-fight",
    excerpt: "一段据称来自某热门选秀综艺后台的录音在网络疯传，录音中两位导师因选手晋级问题激烈争吵，甚至爆出粗口。节目组至今未正面回应，但下期预告中两位导师已无同框镜头。",
    category: "celebrity-scandal",
    categoryName: "明星黑料",
    image: "https://readdy.ai/api/search-image?query=TV%20show%20backstage%20area%20with%20makeup%20mirrors%20and%20bright%20vanity%20lights%2C%20dramatic%20contrast%20lighting%2C%20entertainment%20industry%20setting%2C%20cinematic%20photography&width=800&height=500&seq=article-07-full&orientation=landscape",
    date: "2026-07-03",
    views: 512000,
    comments: 7821,
    tags: ["综艺", "后台", "撕逼"],
    featured: false,
    content: '<p>一段据称来自某热门选秀综艺节目后台的录音近日在网络疯传。录音内容显示，两位导师因一位选手的晋级问题爆发了激烈争吵，言辞之激烈令人咋舌。</p><h3>录音内容曝光</h3><p>在这段长达4分钟的录音中，可以清晰辨认出两位导师的声音。导师A质问导师B：你明明知道他（指某选手）唱歌全程跑调，为什么要给他通过？导师B则反驳：这个节目看的是综合素质，不是只看唱功。你带的人里难道没有唱得差的吗？随后两人情绪逐渐失控，导师A甚至爆了粗口，场面一度剑拔弩张。</p><h3>节目组的异常反应</h3><p>有细心的观众注意到，在该录音曝光后的下一期节目预告片中，这两位导师完全没有任何同框镜头——这在之前的节目中从未发生过。通常预告片会刻意剪辑导师之间的互动来制造话题，此次反常的剪辑似乎从侧面印证了录音的真实性。</p><h3>录音来源成悬疑</h3><p>关于这段录音的来源，网络上众说纷纭。有人猜测是节目组内部工作人员所为，也有人认为可能是某位选手或其团队策划的。更有趣的是，有网友通过声纹分析发现，录音中除了两位导师外，似乎还有第三个人的呼吸声——这意味着录音者当时就在现场。目前，节目组对此事保持沉默，未做任何公开回应。</p>',
  },
  {
    id: 8,
    title: "千万粉美妆博主素颜出镜遭群嘲 粉丝直呼被骗了三年",
    slug: "beauty-blogger-bare-face",
    excerpt: "某美妆博主在一次直播中意外关掉美颜滤镜，真实颜值与平时判若两人。网友纷纷截图对比，话题迅速登上热搜。该博主事后发长文道歉，承认长期使用重度美颜。",
    category: "influencer-flop",
    categoryName: "网红翻车",
    image: "https://readdy.ai/api/search-image?query=Beauty%20studio%20setup%20with%20professional%20makeup%20brushes%20and%20cosmetics%20on%20vanity%20desk%2C%20soft%20warm%20lighting%2C%20feminine%20aesthetic%2C%20clean%20modern%20interior&width=800&height=500&seq=article-08-full&orientation=landscape",
    date: "2026-07-03",
    views: 445000,
    comments: 6230,
    tags: ["美妆", "素颜", "滤镜"],
    featured: false,
    content: '<p>拥有千万粉丝的美妆博主XX酱在一次直播中意外关掉了美颜滤镜，真实的容颜与平时判若两人。这个意外瞬间被网友截图并在各大平台广泛传播，话题迅速登上热搜榜。</p><h3>5秒钟的致命意外</h3><p>据观看直播的网友描述，当晚XX酱正在讲解一款遮瑕产品的使用方法，操作手机时不慎触碰到了滤镜开关。在美颜关闭的约5秒钟内，屏幕上的她呈现出了完全不同的面貌：皮肤变得暗沉粗糙，黑眼圈和法令纹清晰可见，与平时镜头里那个肤如凝脂的形象判若两人。虽然她迅速重新开启了滤镜并若无其事地继续直播，但截图已经在各大粉丝群中炸开了锅。</p><h3>粉丝三年的信任崩塌</h3><p>XX酱在三年前凭借精湛的化妆技巧和甜美的外表走红，她的招牌内容就是教粉丝如何画出完美的日常妆容。如今滤镜翻车后，大量粉丝感到被欺骗：原来我们学了三年不是化妆技巧不行，是你开了三年的重度美颜！</p><h3>道歉长文引发的二次争议</h3><p>事发第二天，XX酱发布了一篇长文道歉。她承认自己在直播中使用了美颜滤镜，但辩称这在美妆博主圈内是普遍做法，目的是为了更好地呈现妆效。然而这番辩解不但没有平息众怒，反而引发了更多质疑：既然是为了呈现妆效，那为什么连素颜测评的视频也要开美颜？这不是自相矛盾吗？</p>',
  },
  {
    id: 9,
    title: "某地烂尾楼业主集体维权 开发商资金链断裂内幕调查",
    slug: "unfinished-building-owner-protest",
    excerpt: "某二线城市千余户业主购买的楼盘烂尾已超两年，开发商拖欠工程款数十亿。记者深入调查发现，该项目早在开盘前就存在资金窟窿，预售资金监管形同虚设。",
    category: "social-hot",
    categoryName: "社会热点",
    image: "https://readdy.ai/api/search-image?query=Unfinished%20construction%20site%20with%20partially%20built%20concrete%20buildings%20against%20overcast%20sky%2C%20documentary%20photography%20style%2C%20somber%20atmosphere%2C%20urban%20landscape&width=800&height=500&seq=article-09-full&orientation=landscape",
    date: "2026-07-02",
    views: 378000,
    comments: 5120,
    tags: ["烂尾楼", "维权", "开发商"],
    featured: false,
    content: '<p>某二线城市千余户业主在7月2日发起了集体维权行动。他们所购买的楼盘烂尾已超过两年，开发商拖欠工程款数十亿元，预售资金监管形同虚设。</p><h3>千余家庭的噩梦</h3><p>该楼盘位于该市新城区核心地段，2023年开始预售时曾引发抢购热潮。每平米均价1.8万元的价格在当时属于中等偏上水平，业主们大多掏空了家庭积蓄才凑齐了首付。然而，项目在2024年初停工后便再未复工，至今已有超过两年时间。记者在现场看到，十几栋楼的主体结构虽已封顶，但外墙、门窗、电梯均未安装，工地内杂草丛生，满目疮痍。</p><h3>预售资金的监管黑洞</h3><p>记者深入调查发现，该项目的预售资金监管账户存在严重问题。按照相关规定，预售资金应当专款专用，全部用于项目建设。但调查显示，开发商通过虚假工程进度证明，分多次将预售资金转移至其他账户，总额超过20亿元。而本该负责监管的银行和住建部门，对此却视而不见。</p><h3>开发商的空壳游戏</h3><p>更令人震惊的是，记者通过企业信息查询发现，涉事开发商的实际控制人在过去两年内已将其名下多家公司的股权进行了层层转移。目前该开发商名下几乎没有任何可执行资产，即便业主们通过法律途径胜诉，也很难追回损失。</p>',
  },
  {
    id: 10,
    title: "知名导演被多名女演员联合举报 娱乐圈MeToo再升级",
    slug: "director-metoo-allegations",
    excerpt: "五位曾与该导演合作过的女演员联合发布声明，指控其在拍摄期间存在不当行为。该导演曾获多项大奖，在圈内地位极高。目前已有多个品牌宣布与其解约。",
    category: "exclusive-expose",
    categoryName: "独家曝光",
    image: "https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20professional%20camera%20equipment%20under%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20warm%20tones%2C%20movie%20production%20setting&width=800&height=500&seq=article-10-full&orientation=landscape",
    date: "2026-07-02",
    views: 756000,
    comments: 12345,
    tags: ["MeToo", "导演", "举报"],
    featured: true,
    content: '<p>娱乐圈MeToo运动再度升级。7月2日，五位曾与某知名导演合作过的女演员联合发布了一份声明，指控该导演在拍摄期间存在严重的不当行为。</p><h3>五份血泪控诉</h3><p>在这份联合声明中，五位女演员分别详细描述了自己在合作期间遭受的骚扰。时间跨度从2018年至2025年，地点涉及片场、酒店、庆功宴等多个场合。其中一位女演员写道：他以讲戏为由，将我叫到他的房间，关上门后就开始说一些与剧本无关的暗示性话语。我找借口离开后，当晚就收到了他的助理发来的消息，说导演对我的表现不太满意，希望我能更配合一些。</p><h3>获奖导演的光环与阴影</h3><p>这位导演在业内以艺术成就著称，曾三次获得国内最佳导演奖，两部作品入围国际A类电影节。正是因为其在业内的地位和人脉，多位受害者表示长期以来不敢发声：每个剧组都抢着要和他合作，得罪他就等于自断前程。</p><h3>品牌解约潮</h3><p>在联合声明发布后的24小时内，已有三个品牌宣布与该导演解除代言合作关系。其中一家奢侈品品牌在声明中表示：我们对任何形式的骚扰行为持零容忍态度。与此同时，该导演正在筹备的新电影项目也被投资方紧急叫停。导演本人目前未对指控做出任何公开回应。</p>',
  },
  {
    id: 11,
    title: "某网红餐厅后厨卫生触目惊心 市场监管局连夜查封",
    slug: "restaurant-hygiene-scandal",
    excerpt: "一家在短视频平台爆火的网红餐厅被前员工曝光后厨实况：蟑螂遍地、食材过期、回收剩菜。视频发布后两小时内播放量破千万，当地市场监管局已连夜查封该店。",
    category: "daily-gossip",
    categoryName: "每日吃瓜",
    image: "https://readdy.ai/api/search-image?query=Dirty%20commercial%20kitchen%20with%20stainless%20steel%20counters%20and%20dim%20lighting%2C%20grimy%20atmosphere%2C%20documentary%20photography%20style%2C%20raw%20realistic&width=800&height=500&seq=article-11-full&orientation=landscape",
    date: "2026-07-01",
    views: 234000,
    comments: 3421,
    tags: ["网红餐厅", "卫生", "查封"],
    featured: false,
    content: '<p>一家在短视频平台拥有数百万粉丝的网红餐厅，近日被前员工曝光了令人触目惊心的后厨卫生状况。蟑螂遍地、食材过期、回收剩菜等问题逐一曝光，引发了全网对餐饮行业监管的热议。</p><h3>前员工的爆料视频</h3><p>7月1日凌晨，一位自称在该餐厅工作了两个月的后厨员工，在其个人社交账号发布了一段长达8分钟的偷拍视频。视频中可以看到：厨房地面上有十余只蟑螂在爬行，其中一个切菜板旁边甚至有蟑螂卵鞘；冷柜中存放的肉类已经发黑变质，上面的保质期标签显示已过期超过一周；最令人作呕的是，服务员将客人吃剩的毛血旺端回厨房，厨师竟然将里面的食材捞出来重新摆盘。</p><h3>前员工的血泪自述</h3><p>爆料人在视频中表示：我本来想好好干活赚钱，但实在看不下去他们这样坑人。我劝过老板不要这样，老板说做餐饮都这样，客人吃不出来就行。我干了两个月，每天良心都在受折磨，实在受不了了才辞职的。</p><h3>监管连夜行动</h3><p>视频发布后两小时内播放量突破千万，当地市场监管局在接到大量网友举报后，凌晨两点组织执法人员对该餐厅进行了突击检查，当场查封了该店。市场监管部门表示：经初步检查，视频反映的问题基本属实，我们将依法从严从重处罚，绝不姑息。</p>',
  },
  {
    id: 12,
    title: "某顶流rapper被前女友爆料出轨多人 聊天记录火辣曝光",
    slug: "rapper-cheating-scandal",
    excerpt: "一位自称是某知名rapper前女友的网友在微博发布长文，附大量聊天截图，指控其在恋爱期间同时与多名女性保持暧昧关系。其中部分聊天内容尺度极大，引发网友疯狂转发。",
    category: "deep-dive",
    categoryName: "深度扒皮",
    image: "https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20professional%20equipment%20and%20dim%20moody%20lighting%2C%20urban%20hip%20hop%20aesthetic%2C%20warm%20dark%20tones%2C%20creative%20atmosphere&width=800&height=500&seq=article-12-full&orientation=landscape",
    date: "2026-07-01",
    views: 634000,
    comments: 8921,
    tags: ["rapper", "出轨", "聊天记录"],
    featured: false,
    content: '<p>一位自称是某知名rapper前女友的网友，7月1日在微博发布了长文，并附上了大量聊天截图。她指控该rapper在两人恋爱期间，同时与至少四名女性保持着暧昧关系。</p><h3>恋爱时间线全梳理</h3><p>根据爆料人提供的时间线，她与该rapper于2025年3月开始交往，2026年4月发现对方出轨后分手。在长达13个月的恋爱关系中，该rapper同时与A女（2025年5月至今）、B女（2025年8月-2026年2月）、C女（2025年12月-2026年5月）和D女（2026年1月至今）保持着不同程度的亲密关系。</p><h3>火辣聊天记录</h3><p>爆料人公开的聊天截图中，该rapper对不同女性使用了几乎一模一样的情话模板。更令人震惊的是，在2026年情人节当天，他竟然在三个小时内分别给四位不同的女性发送了520红包，并附上了相似的情人节表白文案。一位网友调侃道：这聊天记录不去写AI论文可惜了，prompt engineering的水平堪称一流。</p><h3>粉丝的反击与维护</h3><p>事件发酵后，该rapper的粉丝群体迅速组织反击。一部分粉丝指责爆料人恶意抹黑，要求其提供更多证据；另一部分粉丝则认为聊天记录可以伪造，不接受这种形式的爆料。然而，有技术博主对聊天截图的元数据进行了分析，初步判断截图未经过PS处理。该rapper本人目前尚未对此事做出公开回应。</p>',
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export const hotArticles = [...articles]
  .sort((a, b) => b.views - a.views)
  .slice(0, 6);

export const faqItems = [
  {
    question: "911吃瓜网的内容来源是什么？",
    answer: "911吃瓜网的内容来源于网友投稿、媒体公开报道以及团队独立调查。我们始终坚持以事实为依据，对每一条爆料进行多方核实后再发布，确保内容真实可靠。",
  },
  {
    question: "如何向911吃瓜网投稿？",
    answer: "您可以通过网站底部的投稿邮箱或联系我们页面提交爆料线索。我们会严格保护爆料人隐私，所有投稿均采用匿名处理。如果线索被采纳，我们将给予爆料人相应的奖励。",
  },
  {
    question: "911吃瓜网的内容更新频率如何？",
    answer: "911吃瓜网保持每日更新，通常在上午10点和下午6点两个时段集中发布当天的重磅爆料。紧急热点事件我们会第一时间跟进发布，确保您不错过任何一个大瓜。",
  },
  {
    question: "如何获取911吃瓜网的最新地址？",
    answer: "您可以收藏本页面作为911吃瓜网的永久入口。同时建议关注我们的官方社交媒体账号，我们会通过官方渠道第一时间发布最新地址变更通知。",
  },
  {
    question: "网站上的内容可以转载吗？",
    answer: "911吃瓜网的所有原创内容均受版权保护。如需转载，请注明来源并保留原文链接。未经授权的批量抓取和商业转载行为，我们将保留追究法律责任的权利。",
  },
];